<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="" v-model="selectedOrganizationBranch"
                          :options="organizationBranchOptions" :clearable="false">
                    <span slot="no-options">{{ $t('vSelect.noRowsToShow') }}</span>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 sm:mt-0 mt-2 w-full">
                <label class="vs-input--label">Phòng ban</label>
                <v-select class="" v-model="departmentSelect"
                          :options="departmentOptions" :clearable="false">
                    <span slot="no-options">{{ $t('vSelect.noRowsToShow') }}</span>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 md:mt-0 mt-2 w-full">
                <label class="vs-input--label">Nhân viên</label>
                <v-select class="" v-model="selectedEmployee" :options="employeeOptions" :clearable="false">
                    <span slot="no-options">{{ $t('vSelect.noRowsToShow') }}</span>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">Trạng thái</label>
                <v-select class="" v-model="statusModel"
                          :options="statusOptions" :clearable="false">
                    <span slot="no-options">{{ $t('vSelect.noRowsToShow') }}</span>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">Thời gian</label>
                <div class="flex-grow">
                    <date-range-picker
                        class="w-full"
                        ref="picker"
                        :locale-data="{format: 'dd/mm/yyyy' }"
                        :opens="'right'"
                        @update="dateRangePicker"
                        v-model="dateRange">
                    </date-range-picker>
                </div>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full sm:mt-3">
                <vs-button class="mt-5" icon-pack="feather" icon="icon-search" @click="filter">
                    Tìm kiếm
                </vs-button>
            </div>
        </div>

        <!-- <div class="flex flex-wrap items-center mt-5">
            <div class="flex-grow">
            </div>
            <Pagination
                :itemList="listOvertime"
                :currentPage="currentPage"
                :paginationPageSize="paginationPageSize"
                :gridApi="gridApi"
            />

        </div> -->
        <!-- AgGrid Table -->
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="listOvertime"
                     :animateRows="true"
                     :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                     paginationPageSize="20"
                     :pagination="true"
                     @pagination-changed="onPaginationChanged"
                     @grid-ready="onGridReady"
                     :autoSizeStrategy="autoSizeStrategy"
                     tooltipShowDelay="0"
                     tooltipHideDelay="5000">
        </ag-grid-vue>

        <div class="vx-row" v-if="totalElements > 0">
            <div class="vx-col w-full flex">
                <div style="min-width:200px">
                    <span class="content-page font-bold">Hiển thị: </span><span
                    class="text-page">{{
                        countElementPage > totalElements ? totalElements : countElementPage
                    }} / {{ totalElements }} </span>
                </div>
                <vs-pagination

                    :total="totalPages"
                    @change="loadPage"
                    v-model="currentPage"/>
            </div>
        </div>

    </div>
</template>

<script>

import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from 'moment';
import Pagination from "../../ui-elements/Pagination.vue";
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import CellRendererActions from './cell-renderer/CellRendererActions.vue';
// import CellRendererShowDetail from "@/views/user-pages/checkin-location/cell-renderer/CellRendererShowDetail";

export default {
    name: "RemoteTimekeeping",
    components: {
        vSelect,
        AgGridVue,
        Pagination,
        Datepicker,
        DateRangePicker,
        CellRendererStatus,
        CellRendererActions,
        // CellRendererShowDetail
    },
    data() {
        return {
            isFirstCallApi: false,
            departmentOptions: [],
            departmentValue: null,
            //branch
            organizationBranchOptions: [],
            organizationSubBranchOptions: [],
            organizationChilrenBranchOptions: [],
            selectedChilrenOrganizationBranchValue: null,
            selectedOrganizationBranchValue: null,
            selectedSubOrganizationBranchValue: null,
            valueSelectedBranchLevel: null,
            valueSelectedBranchLevel2: null,
            valueSelectedBranchLevel3: null,
            levelBranch: null,
            valueSelectedBranch: null,
            checkValueSelected: false,

            //employee
            selectedEmployeeValue: null,
            employeeOptions: [],

            //date range
            dateRange: {
                startDate: new Date(),
                endDate: (() => {
                    let date = new Date();
                    date.setDate(date.getDate() + 6);
                    date.setHours(0, 0, 0);
                    return date
                })()
            },

            //over time
            listOvertime: [],
            overtimeStatusOptions: [
                {value: null, label: 'Tất cả'},
                {value: 0, label: 'Chờ'},
                {value: 1, label: 'Đã duyệt'},
                {value: 2, label: 'Từ chối'},
                {value: 3, label: 'Hủy bỏ'}
            ],

            //pagination
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'Mã NV',
                    field: 'employeeCode',
                    width: 150,
                    suppressSizeToFit: true,
                },
                {
                    headerName: 'Tên nhân viên',
                    field: 'employeeFullname',
                    width: 150,
                },
                {
                    headerName: 'Địa chỉ',
                    field: 'fullAddress',
                    width: 160,
                },
                {
                    headerName: 'Thời gian bắt đầu',
                    field: 'startTime',
                    width: 140,
                },
                {
                    headerName: 'Thời gian kết thúc',
                    field: 'endTime',
                    width: 140,
                },
                {
                    headerName: 'Thời gian duyệt',
                    field: 'timeUpdate',
                    width: 140,
                },
                {
                    headerName: 'Người duyệt',
                    field: 'approveEmployeeFullName',
                    width: 140,
                },
                {
                    headerName: 'Trạng thái',
                    field: 'displayStatus',
                    cellRenderer: 'CellRendererStatus',
                    width: 100,
                },
                {
                    headerName: 'Hành động',
                    field: 'actions',
                    width: 120,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                },
            ],
            //search
            searchQuery: "",
            status: null,
            branchList: [],
            statusOptions: [
                {value: null, label: 'Tất cả'},
                {value: 0, label: 'Chờ'},
                {value: 1, label: 'Đã duyệt'},
                {value: 2, label: 'Từ chối'},
                {value: 3, label: 'Hủy bỏ'}
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
        }
    },
    watch: {
        '$store.state.isUpdateOvertime'(val) {
            if (val) {
                this.getListOverTime();
                this.$store.commit('UPDATE_OVERTIME', false);
            }
        }
    },
    computed: {
        overtimeStatusModel: {
            get() {
                let object = this.overtimeStatusOptions.find(el => el.value === this.status);
                return {
                    label: object ? object.label : 'Chưa xác định',
                    value: this.status
                }
            },
            set(obj) {
                this.status = obj.value;
            }
        },
        selectedOrganizationBranch: {
            get() {
                let obj = this.organizationBranchOptions.find(el => el.value === this.selectedOrganizationBranchValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null;
                this.refreshValueSelected();
                this.getDepartment();
                this.loadEmployee()

            }
        },
        selectedEmployee: {
            get() {
                let obj = this.employeeOptions.find(el => el.value === this.selectedEmployeeValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        },
        statusModel: {
            get() {
                return {
                    label: this.statusOptions.find(x => x.value === this.status).label,
                    value: this.status
                }
            },
            set(obj) {
                this.status = obj.value;
            }
        },
        departmentSelect: {
            get() {
                let object = this.departmentOptions.find(el => el.value === this.departmentValue);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.departmentValue = object ? object.value : null;
                this.isFirstCallApi = true;
                this.refreshValueSelectedDepartment();
                this.loadEmployee();

            }
        },
    },
    methods: {
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        refreshValueSelected: function () {
            this.departmentValue = null;
            this.selectedEmployeeValue = null;
        },
        refreshValueSelectedDepartment: function () {
            this.selectedEmployeeValue = null;
        },
        getDepartment: function () {
            const payload = {
                organizationBranchId: this.selectedOrganizationBranchValue,
            }
            this.$crm.post('/department/find-by-condition', payload).then((res) => {
                this.departmentOptions = res.data.map(el => {
                    return {
                        label: el.departmentName,
                        value: el.id
                    }
                })
                this.departmentOptions.unshift({label: 'Tất cả', value: null})
            }).catch((err) => {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
        getListOverTime() {
            this.$vs.loading();
            const payload = {
                departmentId: this.departmentValue,
                employeeId: this.selectedEmployeeValue,
                organizationBranchId: this.selectedOrganizationBranchValue,
                status: this.status,
                fromDate: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 999})
            }
            this.$crm.post('employee-location-checkin/find-by-condition', payload).then((res) => {
                let result = res.data;
                if (this.valueSelectedBranch) result = result.filter(el => el.organizationBranchId == this.valueSelectedBranch);
                let listCI = result.map(item => {
                    item.startTimeApprove = item.startTime
                    item.endTimeApprove = item.endTime
                    item.startTime = moment(item.startTime).format('DD/MM/YYYY');
                    item.endTime = moment(item.endTime).format('DD/MM/YYYY');
                    item.displayStatus = item.status === 0 ? 'Chờ' : item.status === 1 ? 'Đã duyệt' : item.status === 2 ? 'Từ chối' : 'Hủy';
                    item.timeUpdate = (item.status === 1 || item.status === 2) ? moment(item.modifiedDate).format('DD/MM/YYYY HH:mm:ss') : '';
                    return item;
                });
                this.listOvertime = listCI.reverse();
                this.countElementPage = this.currentPage * 20;
                this.totalElements = this.listOvertime.length;
                this.$vs.loading.close();
            }).catch(() => {
                this.$vs.loading.close();
            })
        },
        loadEmployee() {
            this.$vs.loading();
            const payload = {
                departmentId: this.departmentType,
                organizationBranchId: this.selectedOrganizationBranchValue,
            }

            this.$crm.post('/employee/all', payload).then((response) => {
                if (response.data.length !== 0) {
                    this.checkEmployee = false;
                } else {
                    this.checkEmployee = true;
                }
                this.employeeOptions = response.data.map(el => {
                    return {
                        label: el.employeeCode + '_' + el.fullName,
                        value: el.employeeId,
                    }
                });
                this.employeeOptions.unshift({value: null, label: 'Tất cả'})
                this.employeeOptions = this.employeeOptions.sort((x, y) => {
                    return y.employeeId - x.employeeId
                })
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        filter() {
            this.getListOverTime()
            this.currentPage = 1;
            if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
        }
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.organizationBranchOptions.unshift({value: null, label: 'Tất cả'})

        this.getListOverTime()

        let branchId = this.$route.query.branch_id;
        let index = 0;
        if (branchId) {
            index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
        }

        this.getDepartment();
        this.loadEmployee();
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
